export enum DimensionUnitType {
  CENTIMETER,
  METER,
  FOOT
}

export enum DistanceUnitType {
  KILOMETER,
  MILE
}

export enum MassUnitType {
  POUNDS,
  KILOGRAMS,
  OUNCE
}

export enum VolumnUnitType {
  MILLILITER,
  LITER,
  GALLON
}

export enum TimeUnitType {
  MINUTES,
  HOURS,
  DAYS,
  YEARS
}

export enum TorqueUnitType {
  NEWTON_METER,
  FOOT_POUND,
  INCH_POUND
}

export enum ReadingType {
  MILES,
  HOURS
}

export enum DimensionUnitLabelType {
  CENTIMETER = 'cm',
  METER = 'm',
  FOOT = 'ft'
}

export enum DistanceUnitLabelType {
  KILOMETER = 'km',
  MILE = 'mi'
}

export enum MassUnitLabelType {
  POUNDS = 'lb',
  KILOGRAMS = 'kg',
  OUNCE = 'oz'
}

export enum VolumnUnitLabelType {
  MILLILITER = 'mL',
  LITER = 'L',
  GALLON = 'gal'
}

export enum TimeUnitLabelType {
  MINUTES = 'Mins',
  HOURS = 'Hours',
  DAYS = 'Days',
  YEARS = 'Years'
}

export enum TorqueUnitLabelType {
  NEWTON_METER = 'Nm',
  FOOT_POUND = 'ft-lb',
  INCH_POUND = 'in-lb'
}

export enum ReadingLabelType {
  MILES = 'Miles',
  HOURS = 'Hours'
}
